<template>
  <div class="app-wrapper">
    <div class="app">
      <Navigation v-if="!navigation" />
      <router-view v-if="this.$store.state.postLoaded"/>
      <div class="waiting-gif" v-if="!this.$store.state.postLoaded">
        <div>
          <img :src='require("@/assets/loading-fast.gif")' alt="">
        </div>
      </div>
      <Footer class="footer" v-if="!navigation" />
    </div>
  </div>
</template>

<script>
import Navigation from './components/common/Navigation';
import Footer from './components/common/Footer.vue';
// import WaitOneMin from './assets/mona-loading-dark.gif';

import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'App',
  components: {
    Navigation,
    Footer,
    // WaitOneMin
  },
  data() {
    return {
      navigation: null,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.$store.commit('updateUser', user);
      if (user) {
        this.$store.dispatch('getCurrentUser');

        setTimeout(() => {
        }, 2000);
      }
    });

    this.checkRoute();
    this.$store.dispatch('getPost');
    this.$store.dispatch('getResumes', this.$store.state.profileId);
  },
  mounted() {},
  methods: {
    checkRoute() {
      if (
        this.$route.name === 'Login' ||
        this.$route.name === 'Register' ||
        this.$route.name === 'ForgotPassword' ||
          this.$route.name === 'EditResume'
      ) {
        this.navigation = true;
        return;
      }
      this.navigation = false;
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Quicksand', sans-serif;
}
ul {
  list-style: none;
  padding: 0;
}
.waiting-gif {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 200px;
    margin: 50px auto;
  }
}


.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
}

.link {
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  color: black;
}

.link-light {
  color: #fff;
}

.arrow {
  margin-left: 8px;
  width: 12px;
  path {
    fill: #000;
  }
}
.arrow-light {
  path {
    fill: #fff;
  }
}

.router-button {
  transition: 500ms ease all;
  cursor: pointer;
  margin-top: 24px;
  padding: 12px 24px;
  background-color: #303030;
  color: #fff;
  border-radius: 20px;
  border: none;
  text-transform: uppercase;

  &:focus {
    outline: none;
  }
  &:hover {
    background-color: rgba(48, 48, 48, 0.7);
  }
}

.button-ghost {
  color: #000;
  padding: 0;
  border-radius: 0;
  margin-top: 50px;
  font-size: 15px;
  font-weight: 500;
  background-color: transparent;
  @media (min-width: 700px) {
    margin-top: 0;
    margin-left: auto;
  }

  i {
    margin-left: 8px;
  }
}

.button-light {
  background-color: transparent;
  border: 2px solid #fff;
  color: #fff;
}

.button-inactive {
  pointer-events: none !important;
  cursor: none !important;
  background-color: rgba(128, 128, 128, 0.5) !important;
}

button {
  border: none;
  background-color: transparent;
  font-size: 16px;
  transition: 200ms ease all;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }
}
.primary-button {
  transition: 500ms ease all;
  cursor: pointer;
  background-color: rgb(33, 150, 243);
  color: #fff;
  border-radius: 3px;
  border: none;
  font-size: 16px;
  padding: 5px 7px;

  &:focus {
    outline: none;
  }
  &:hover {
    background-color: rgb(22, 138, 230);
  }
}

.error {
  text-align: center;
  font-size: 12px;
  color: red;
}

.blog-card-wrap {
  position: relative;
  padding: 80px 16px;
  background-color: #f1f1f1;
  @media (min-width: 500px) {
    padding: 100px 16px;
  }

  .blog-cards {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;

    @media (min-width: 500px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1200px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}


</style>
